module.exports = __webpack_public_path__ + "media/images/vp/icon.filter.white-431ffb0e4adb16410389806f14d1fc9f.svg";